import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { PdfViewerComponent } from '../pdfviewer/pdfviewer.component';

@Component({
    selector: 'app-hypervergekycaudit',
    templateUrl: './hypervergekycaudit.component.html',
    styleUrls: ['./hypervergekycaudit.component.css']
})
export class HypervergeKYCAuditComponent implements OnInit {
    filter: any = {
        fromDate: moment().format('yyyy-MM-DD'),
        toDate: moment().format('yyyy-MM-DD')
    };
    displayedColumns = [
        'data',
        'status',
        'metadata',
        'user_name',
        'applicationStatus',
        'createdAt',
    ];
    public dataSource: any = new MatTableDataSource();
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.applyRefreshData();
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.filter['fromDate'] = moment(event.value).format('yyyy-MM-DD');
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.filter['toDate'] = moment(event.value).format('yyyy-MM-DD');
    }
    generatePDF(element: any): void {
        this.dialog.open(PdfViewerComponent, { data: element, minWidth: '60%' })
        .afterClosed().subscribe(result => {
        });
      }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.userService.getAllHypevergeAudit(this.filter).subscribe((success) => {
                let hypervergeAuditRes = success.map(hypevergeAudit => {
                    hypevergeAudit.metadata = hypevergeAudit.metadata.transactionId
                    hypevergeAudit.user_name = hypevergeAudit.user_id.name
                    hypevergeAudit.createdAt = moment(hypevergeAudit.createdAt).format('MM/DD/YY h:mm:ss A');
                    return hypevergeAudit;
                })
                this.dataSource = new MatTableDataSource(hypervergeAuditRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    displayProperJson(jsonData) {
        let obj = {
            jsonData: JSON.parse(JSON.stringify(jsonData)),
        }
        this.dialog.open(ProperJsonDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: obj,
        }).afterClosed().subscribe(result => {
        });
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const hyperverge_kyc_audit = await this.dataSource.filteredData.map(x => ({
                'status': x.status,
                'metadata': x.metadata,
                'user_name': x.user_name,
                'applicationStatus': x.applicationStatus,
                'createdAt': x.createdAt
            }));
            TableUtil.exportArrayToExcel(hyperverge_kyc_audit, "Hyperverge KYC Audit Report");
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/hypervergekycaudit/hypervergekycaudit.component.ts